var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { key: "loading", staticClass: "flex col-span-12 justify-center" },
          [_vm._m(0)]
        )
      : _c(
          "div",
          { staticClass: "grid grid-cols-12 gap-y-lg sm:gap-x-md md:gap-y-xl" },
          _vm._l(_vm.articles, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "col-span-12 xs:col-span-6 sm:col-span-4",
              },
              [_c("blogitem", { attrs: { content: item } })],
              1
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }